import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { CapacitySearch } from '../interface/capacity-search';

@Injectable({
	providedIn: 'root',
})
export class TopSearchesService {
	constructor(private urlService: UrlService, private restService: RestService) {}

	ngOnInit() {}

	public fetch(): Observable<CapacitySearch[]> {
		const url = this.urlService.topSearchesUrl();
		return this.restService.GET(url);
	}
}
